/* eslint no-console: 0 */
import React, {Component, PropTypes} from 'react';
import {Modal} from 'react-bootstrap';
import characterImage from '../../images/esmeralda_goober_half_wave.png';
import gooberLeaps from '../../images/Goober_leaps.jpg';
import './buyNowModal.scss';
import {getPrice, createCCToken, processCharge, getValidUntilTime} from '../../services/payment';
import promoCodeService from '../../services/promoCode';

const STEPS = {
  SPLASH: 0,
  PRICE: 1,
  PAYMENTINFO: 2,
  CONFIRM: 3
};
const INITIAL_STATE = {
  step: STEPS.SPLASH,
  promoCode: null,
  confirmedDuration: false,
  error: null,
  disableContinue: false
};

export default class BuyNowModal extends Component {

  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    onChargeProcessed: PropTypes.func.isRequired,
    programName: PropTypes.string.isRequired,
    programId: PropTypes.string.isRequired,
    sessionId: PropTypes.string.isRequired
  };

  static contextTypes = {
    profile: PropTypes.object.isRequired,
    userId: PropTypes.string.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = INITIAL_STATE;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showModal !== nextProps.showModal) {
      this.setState(INITIAL_STATE);
    }
  }

  cancel(evt) {
    const {closeModal} = this.props;
    closeModal();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  captureFormRef(form) {
    this._form = form;
  }

  _advanceToNextStep() {
    this.setState({step: this.state.step + 1});
  }

  _chargeCreditCard() {
    const self = this;
    const {onChargeProcessed, sessionId, programName, programId} = this.props;
    const {promoCode} = this.state;
    const {profile, userId} = this.context;
    const {email} = profile;

    return createCCToken(this._form)
      .then(token => {
        const price = getPrice(profile);
        const {amount, currency} = price;
        const validUntil = new Date(getValidUntilTime());
        const validUntilYear = validUntil.getFullYear();
        const chargeData = {
          stripeToken: token,
          promoCode: promoCode ? promoCode.code : '',
          email: email,
          amount: amount,
          currency: currency,
          description: `${programName} classroom licence til June 30, ${validUntilYear}`,
          metadata: {
            sessionId: sessionId,
            email: email,
            userId: userId
          }
        };
        return processCharge(chargeData);
      })
      .then(charge => {
        const sessionPaidForData = {
          charge,
          promoCode,
          sessionId,
          programId
        };
        return onChargeProcessed(sessionPaidForData);
      })
      .then(() => {
        self._advanceToNextStep();
      })
      .catch(error => {
        console.log(error);
        self.setState({error: error.message});
      });
  }

  nextStep(evt) {
    const self = this;
    const {closeModal} = this.props;
    const {step: currentStep} = this.state;
    evt.target.disabled = true;
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
    switch (currentStep) {
    case STEPS.CONFIRM:
      closeModal();
      break;
    case STEPS.PAYMENTINFO:
      this._chargeCreditCard()
        .then(() => evt.target.disabled = false);
      return;
    default:
      self._advanceToNextStep();
    }
    evt.target.disabled = false;
  }

  checkPromoCode(evt) {
    const self = this;
    const value = evt.target.value;
    if (!value) {
      self.setState({promoCode: null, error: null});
      return;
    }
    if (!promoCodeService.isValidFormat(value)) {
      self.setState({promoCode: null, error: 'Invalid format for promo-code.'});
      return;
    }
    promoCodeService.fetch(value)
      .then(promoCode => {
        if (!promoCode) {
          self.setState({promoCode: null, error: 'Sorry, this promo code is invalid.'});
          return;
        }
        if (!promoCode.isAvailable()) {
          self.setState({promoCode: null, error: 'Sorry, this promo code is expired.'});
          return;
        }
        if (!promoCode.isValidForProgram(this.props.programId)) {
          self.setState({promoCode: null, error: 'Sorry, this promo code is not valid for this program.'});
          return;
        }
        self.setState({promoCode: promoCode, error: null});
      })
      .catch(error => {
        console.log(error);
        self.setState({error: 'Problem while retrieving the promo-code. Please try again later.'});
      });
  }

  handleConfirmDurationClick() {
    this.setState({ confirmedDuration: !this.state.confirmedDuration });
  }

  handleSubmit(evt) {
    // Make sure the form doesn't get submitted
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  validateField(evt) {
    const element = evt.target;
    const value = element.value;
    const { dataset } = element;
    const { validationRegex, validationRequired, validationName } = dataset;

    if (validationRequired && !value) {
      this.setState({error: `${validationName} is required.`});
      return;
    }

    if (validationRegex && !(new RegExp(validationRegex).test(value))) {
      this.setState({error: `Invalid ${validationName}.`});
      return;
    }

    this.setState({error: null});
  }

  render() {
    const {
      showModal,
      closeModal,
      programName,
      sessionId
    } = this.props;
    const {
      error,
      step,
      confirmedDuration,
      promoCode
    } = this.state;
    const {
      profile
    } = this.context;

    const price = getPrice(profile);
    const {amount, currency} = price;
    let disableContinue = !!error;
    if (step === STEPS.PRICE) {
      disableContinue = disableContinue || !confirmedDuration;
    }

    const finalAmount = amount - (promoCode ? promoCode.value : 0);

    return (
      <Modal show={showModal} onHide={closeModal} className="buy-now">
        <Modal.Header closeButton>
          <Modal.Title>Buy {programName} for your classroom!</Modal.Title>
        </Modal.Header>
        <form onSubmit={::this.handleSubmit} ref={::this.captureFormRef}>
          <Modal.Body>

            <input type="hidden" name="sessionId" defaultValue={sessionId} />
            <input type="hidden" name="funding" value="STRIPE" />
            <input type="hidden" name="promoCode" value={promoCode ? promoCode.code : ''} />

            <div className="row">
              {step === STEPS.SPLASH &&
              <div className="col-sm-8 col-md-12">
                <div className="col-md-6">
                  <img className="col-md-12 col-xs-6" src={characterImage}/>
                </div>
                <div className="col-md-6">
                  <h3>Hurray!</h3>
                  <h4>You're bringing the Academy to your classroom!</h4>
                </div>
              </div>
              }
              {step === STEPS.PRICE &&
              <div className="col-sm-8 col-md-12">
                <div className="col-md-6">
                  <img className="col-md-12 col-xs-6" src={characterImage}/>
                </div>
                <div className="col-md-6">
                  {error &&
                  <div className="form-group">
                    <div className="alert alert-danger">
                      {error}
                    </div>
                  </div>
                  }
                  <div className="form-group">
                    <label className="control-label"><h4>Get full access for the year for only {amount} {currency}</h4></label>
                  </div>
                  <div className="form-group">
                    <label className="control-label">Have a promo code? Use it here!</label>
                    <input
                      className="form-control promoCode"
                      name="promoCode"
                      type="text"
                      size="10"
                      maxLength="10"
                      autoFocus
                      onBlur={::this.checkPromoCode}/>
                  </div>
                  <div className="promoCodeValue">
                    {promoCode &&
                    `Promo code VALID! You get the discounted price of ${finalAmount} ${currency}`}
                  </div>
                  <div className="form-group confirmDuration">
                    <input
                      type="checkbox"
                      name="confirmDuration"
                      onClick={::this.handleConfirmDurationClick} />
                    <span> I understand that I'm buying access to the program for this school year only (expires June 30th)</span>
                  </div>
                </div>
              </div>
              }
              {step === STEPS.PAYMENTINFO &&
              <div className="col-sm-8 col-md-12">
                {error &&
                <div className="form-group">
                  <div className="alert alert-danger">
                    {error}
                  </div>
                </div>
                }
                <div><h4>We accept all major credit and debit cards including Visa, Mastercard and AmEx.</h4></div>
                <div className="form-group">
                  <label>Card Number:</label>
                  <input type="text"
                         className="form-control input-sm cc-input"
                         size="24"
                         maxLength="16"
                         data-validation-regex="^[0-9]{16}$"
                         data-validation-required
                         data-validation-name="Card Number"
                         onBlur={::this.validateField}
                         autoFocus
                         data-stripe="number"/>
                </div>
                <div className="form-group">
                  <label>Expiration (MM/YY):</label>
                  <div className="expCvcRow">
                    <input type="text"
                           className="form-control input-sm exp-input"
                           data-validation-regex="^0[0-9]|1[0-2]$"
                           data-validation-required
                           data-validation-name="Expiration Month"
                           onBlur={::this.validateField}
                           size="2"
                           maxLength="2"
                           data-stripe="exp_month"/>
                    /
                    <input type="text"
                           className="form-control input-sm exp-input"
                           data-validation-regex="^[0-9]{2}$"
                           data-validation-required
                           data-validation-name="Expiration Year"
                           onBlur={::this.validateField}
                           size="2"
                           maxLength="2"
                           data-stripe="exp_year"/>

                    <label className="">CVC:</label>
                    <input type="text"
                           className="form-control input-sm cvc-input"
                           data-validation-regex="^[0-9]{3,4}$"
                           data-validation-required
                           data-validation-name="CVC"
                           onBlur={::this.validateField}
                           size="4"
                           maxLength="4"
                           data-stripe="cvc"/>
                  </div>
                </div>
              </div>
              }
              {step === STEPS.CONFIRM &&
              <div className="col-sm-8 col-md-12">
                <div className="col-md-6">
                  <img className="col-md-12 col-xs-6 gooberLeaps" src={gooberLeaps}/>
                </div>
                <div className="col-md-6">
                  <h3>SUCCESS!</h3>
                  <h4>You now have full access to {programName} for your classroom!</h4>
                  <h4>A confirmation email will be sent to you.</h4>
                  <h4>Happy planet protecting!</h4>
                </div>
              </div>
              }
            </div>

          </Modal.Body>
          <Modal.Footer>
            {(step < STEPS.CONFIRM) &&
            <button
              className="btn btn-secondary"
              onClick={::this.cancel}>
              Cancel
            </button>
            }
            {' '}
            <button
              className="btn btn-primary"
              onClick={::this.nextStep}
              disabled={disableContinue?'disabled':''}>
              {(step < STEPS.CONFIRM)
                ? `Continue`
                : `Let's Go!`
              }
            </button>
          </Modal.Footer>

        </form>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/dashboard/buyNowModal.jsx